import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Menu, X, Sparkles, Droplet, Scissors, Sun } from 'lucide-react';
const services = [{
  id: 'lash-extensions',
  name: 'Lash Extensions',
  description: 'Diseño personalizado para tu forma de ojo',
  icon: Sparkles
}, {
  id: 'henna-brows',
  name: 'Henna Brows',
  description: 'Definición natural que dura semanas',
  icon: Droplet
}, {
  id: 'thread-eyebrows',
  name: 'Thread Eyebrows',
  description: 'Precisión sin dolor, forma perfecta',
  icon: Scissors
}, {
  id: 'tanning',
  name: 'Tanning',
  description: 'Luminosidad y color natural para tu piel',
  icon: Sun
}];
export function Header() {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`sticky top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md border-b border-gold/20 py-2 shadow-sm' : 'bg-white py-4'}`} data-id="element-142">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-143">
        {/* Logo */}
        <a href="#" className="flex items-center" data-id="element-144">
          <img src="https://cdn.magicpatterns.com/uploads/vyXCETdPnyWa5ugqEt3PN3/heylloyd-image-1777582546768.png" alt="Ingri Lashes Logo" className="h-20 md:h-32 object-contain transition-all duration-300" data-id="element-145" />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-146">
          <a href="#" className="font-sans uppercase tracking-widest text-sm transition-colors hover:text-gold text-ink-dark font-medium" data-id="element-147">
            Inicio
          </a>

          <div className="relative" onMouseEnter={() => setIsServicesOpen(true)} onMouseLeave={() => setIsServicesOpen(false)} data-id="element-148">
            <button className="flex items-center gap-1 font-sans uppercase tracking-widest text-sm transition-colors hover:text-gold py-6 text-ink-dark font-medium" data-id="element-149">
              Servicios{' '}
              <ChevronDown size={16} className={`transition-transform duration-300 ${isServicesOpen ? 'rotate-180' : ''}`} data-id="element-150" />
            </button>

            <AnimatePresence data-id="element-151">
              {isServicesOpen && <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: 10
            }} transition={{
              duration: 0.2
            }} className="absolute top-full left-1/2 -translate-x-1/2 w-72 bg-white shadow-xl rounded-sm border border-gold/20 overflow-hidden" data-id="element-152">
                  <div className="py-2" data-id="element-153">
                    {services.map((service, idx) => {
                  const Icon = service.icon;
                  return <a key={idx} href={`#${service.id}`} className="flex items-start gap-3 px-5 py-3 hover:bg-cream transition-colors group" onClick={() => setIsServicesOpen(false)} data-id="element-154">
                          <Icon size={18} className="text-gold mt-0.5 group-hover:scale-110 transition-transform" data-id="element-155" />
                          <div data-id="element-156">
                            <div className="font-serif text-lg text-ink-dark" data-id="element-157">
                              {service.name}
                            </div>
                            <div className="text-xs text-ink-light font-sans" data-id="element-158">
                              {service.description}
                            </div>
                          </div>
                        </a>;
                })}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>

          <a href="#nosotros" className="font-sans uppercase tracking-widest text-sm transition-colors hover:text-gold text-ink-dark font-medium" data-id="element-159">
            Nosotros
          </a>

          <a href="#testimonios" className="font-sans uppercase tracking-widest text-sm transition-colors hover:text-gold text-ink-dark font-medium" data-id="element-160">
            Testimonios
          </a>

          <a href="#contacto" className="font-sans uppercase tracking-widest text-sm transition-colors hover:text-gold text-ink-dark font-medium" data-id="element-161">
            Contacto
          </a>

          <a href="#reserva" className="px-6 py-2.5 text-sm uppercase tracking-widest border transition-all duration-300 font-bold border-gold text-gold-dark hover:bg-gold hover:text-white" data-id="element-162">
            Reservar Turno
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className={`md:hidden ${scrolled ? 'text-ink-dark' : 'text-ink-dark'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-163">
          {isMobileMenuOpen ? <X size={28} data-id="element-164" /> : <Menu size={28} data-id="element-165" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence data-id="element-166">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-gold/20 overflow-hidden absolute top-full left-0 w-full shadow-lg" data-id="element-167">
            <div className="px-6 py-6 flex flex-col gap-6" data-id="element-168">
              <a href="#" className="font-sans uppercase tracking-wider text-sm text-ink-dark font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-169">
                Inicio
              </a>

              <div data-id="element-170">
                <div className="font-sans uppercase tracking-wider text-sm text-ink-light mb-4" data-id="element-171">
                  Servicios
                </div>
                <div className="flex flex-col gap-4 pl-4 border-l border-gold/30" data-id="element-172">
                  {services.map((service, idx) => <a key={idx} href={`#${service.id}`} className="font-serif text-xl text-ink-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-173">
                      {service.name}
                    </a>)}
                </div>
              </div>

              <a href="#nosotros" className="font-sans uppercase tracking-wider text-sm text-ink-dark font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-174">
                Nosotros
              </a>
              <a href="#testimonios" className="font-sans uppercase tracking-wider text-sm text-ink-dark font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-175">
                Testimonios
              </a>
              <a href="#contacto" className="font-sans uppercase tracking-wider text-sm text-ink-dark font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-176">
                Contacto
              </a>

              <a href="#reserva" className="border border-gold text-gold-dark text-center py-4 text-sm uppercase tracking-widest mt-4 hover:bg-gold hover:text-white transition-colors font-bold" onClick={() => setIsMobileMenuOpen(false)} data-id="element-177">
                Reservar Turno
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}